module.exports = __webpack_public_path__ + "media/images/top/pap/common/img_step01-617127baa2b15daeec53ddcc16dab954.png";